import type { LocationQuery } from 'vue-router'

import { parseArrayParam, parseStringParam } from '@shared/lib/url'

export interface CustomerTaskCommentsFilterParams {
  discipline_id: string[]
  created_from: string | null
  created_to: string | null
  team: string[]
  task_type: string[]
}

export const parseFilterParams = (query: LocationQuery): CustomerTaskCommentsFilterParams => {
  return {
    discipline_id: parseArrayParam(query, 'discipline_id'),
    created_from: parseStringParam(query, 'created_from'),
    created_to: parseStringParam(query, 'created_to'),
    team: parseArrayParam(query, 'team'),
    task_type: parseArrayParam(query, 'task_type'),
  }
}

export const buildQueryObject = (params: CustomerTaskCommentsFilterParams): Record<string, string> => {
  const query: Record<string, string> = {}

  if (params.created_from) query.created_from = params.created_from
  if (params.created_to) query.created_to = params.created_to

  params.discipline_id.forEach((v, i) => { query[`discipline_id[${i}]`] = v })
  params.team.forEach((v, i) => { query[`team[${i}]`] = v })
  params.task_type.forEach((v, i) => { query[`task_type[${i}]`] = v })

  return query
}